import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { Button, Container, Icon } from 'semantic-ui-react'
import { AiOutlineLaptop } from 'react-icons/ai'
import { loadPlatforms, updateState, removePlatform } from '../Slice/PlatformSlice'
import ListTable from '../../Common/Views/ListTable'
import DeleteConfirmModal from '../../Common/Views/DeleteConfirmModal'
import './css/PlatformListPage.css'

export default function PlatformListPage () {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const {
    list,
    filter,
    totalPages,
    isLoading,
    isError,
    message
  } = useSelector((state) => state.platform)
  const [deletePlatform, setDeletePlatform] = useState({})

  const columns = [
    {
      name: 'id',
      title: 'generic.id',
      filter: false,
      props: {
        textAlign: 'right',
        width: 1
      }
    },
    {
      name: 'name',
      title: 'generic.name'
    },
    {
      name: 'tag',
      title: 'generic.tag'
    },
    {
      name: 'abbr',
      title: 'generic.abbr'
    }
  ]

  useEffect(() => {
    onReload(filter)
  }, [])

  const onReload = (payload) => {
    dispatch(loadPlatforms(payload))
  }

  useEffect(() => {
    if (isError && message) {
      toast.error(message)
      dispatch(updateState())
    }
  }, [isError, message])

  const onEdit = (platformId) => {
    navigate(`/platform/${platformId}`)
  }
  const onDelete = (platform) => {
    setDeletePlatform(platform)
  }

  const handleDeletePlatform = () => {
    dispatch(removePlatform(deletePlatform.id))
    setDeletePlatform({})
  }

  return (
    <Container className='platform-list-page'>
      <div className='platform-title'>
        <Icon size='large'><AiOutlineLaptop /></Icon>
        <span>{ t('menu.platforms') }</span>
        <Button
          floated='right'
          icon
          labelPosition='left'
          primary
          size='large'
          onClick={() => navigate('/platform/new')}>
          <Icon name='laptop' /> { t('platform.new') }
        </Button>
      </div>
      <ListTable color='violet'
                 isLoading={isLoading}
                 columns={columns}
                 filter={filter}
                 data={list}
                 totalPages={totalPages}
                 onReload={onReload}
                 onEdit={onEdit}
                 onDelete={onDelete} />
      <>
        <DeleteConfirmModal open={ !!deletePlatform.id }
                            title={ t('platform.deleteTitle') }
                            message={ t('platform.deleteQuestion') }
                            item={ deletePlatform.name }
                            onCancel={ () => setDeletePlatform({}) }
                            onDelete={ handleDeletePlatform } />
      </>
    </Container>
  )
}
